import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node.isRequired
};
function UIGrid(_ref) {
  let {
      children,
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
    className: classNames('row', className),
    children: children
  }));
}
UIGrid.propTypes = propTypes;
UIGrid.displayName = 'UIGrid';
export default UIGrid;